var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "85px",
    height: "85px",
    viewBox: "0 0 85 85",
    enableBackground: "new 0 0 85 85",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M62.373,34.586h3.434 c1.65,0,3,1.35,3,3v32.417c0,1.649-1.35,3-3,3H19.193c-1.65,0-3-1.351-3-3V37.586c0-1.65,1.35-3,3-3h18.653"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M25.006,52.725"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M25.006,42.636"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "40.312,72.959 40.312,52.446 45.225,48.667  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 40.224,
    y1: 62.632,
    x2: 28.057,
    y2: 62.632
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    x1: 59.155,
    y1: 55.729,
    x2: 51.525,
    y2: 55.72
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    x1: 35.964,
    y1: 43.743,
    x2: 16.266,
    y2: 43.733
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    x1: 27.925,
    y1: 73.006,
    x2: 27.925,
    y2: 34.625
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "59.198,72.794 59.198,46.808 68.766,46.808  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M61.276,23.085 c0,6.125-11.091,24.802-11.091,24.802s-11.09-18.677-11.09-24.802s4.965-11.09,11.09-11.09S61.276,16.96,61.276,23.085z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#394553",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 50.186,
    cy: 23.085,
    r: 4.736
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.68b7d5ec93b093954dfe3d7067115868.svg";
export { ForwardRef as ReactComponent };